import React, { type ReactNode } from 'react';

import { Box } from '@atlaskit/primitives/compiled/box';

export type SessionContextProps = {
	context: ReactNode;
	testId?: string;
};

/** Renders display-ready associated context, such as a Jira issue or Confluence link. */
export const SessionContext = ({
	context,
	testId,
}: SessionContextProps): React.JSX.Element | null => {
	if (context === undefined || context === null || context === false) {
		return null;
	}

	return (
		<Box as="span" testId={testId}>
			{context}
		</Box>
	);
};
